import { useAppState } from '../useAppState';

export const useReservationsCache = () => {
  const { reservationsCache } = useAppState();

  return reservationsCache;
};
